export const components = {
  CAccordion: () => import('./CAccordion/CAccordion'),
  CAccordionFeatures: () => import('./CAccordionFeatures/CAccordionFeatures'),
  CBeforeAfterImage: () => import('./CBeforeAfterImage/CBeforeAfterImage'),
  CBox: () => import('./CBox/CBox'),
  CToggleTab: () => import('./CToggleTab/CToggleTab'),
  CBulletList: () => import('./CBulletList/CBulletList'),
  CLinkList: () => import('./CLinkList/CLinkList'),
  CSocialLinks: () => import('./CSocialLinks/CSocialLinks'),
  CPillsList: () => import('./CPillsList/CPillsList'),
  CTyper: () => import('./CTyper/CTyper'),
  CButton: () => import('./CButton/CButton'),
  CButtonGroup: () => import('./CButtonGroup/CButtonGroup'),
  CAvatar: () => import('./CAvatar/CAvatar'),
  COrderForm: () => import('./CCheckout/CCheckout'),
  COrderConfirmation: () => import('./COrderConfirmation/COrderConfirmation'),
  CCountdown: () => import('./CCountdown/CCountdown'),
  CDivider: () => import('./CDivider/CDivider'),
  CFactBox: () => import('./CFactBox/CFactBox'),
  CHtml: () => import('./CHtml/CHtml'),
  CImage: () => import('./CImage/CImage'),
  CImageBox: () => import('./CImageBox/CImageBox'),
  CRating: () => import('./CRating/CRating'),
  CImageGrid: () => import('./CImageGrid/CImageGrid'),
  CEndorsementGroup: () => import('./CEndorsementGroup/CEndorsementGroup'),
  CImageAndText: () => import('./CImageAndText/CImageAndText'),
  CInlineCountdown: () => import('./CInlineCountdown/CInlineCountdown'),
  CMultiStepForm: () => import('./CMultiStepForm/CMultiStepForm'),
  CInspiration: () => import('./CInspiration/CInspiration'),
  CReviews: () => import('./CReviews/CReviews'),
  CQuoteTestimonial: () => import('./CQuoteTestimonial/CQuoteTestimonial'),
  CInlineCountdown: () => import('./CInlineCountdown/CInlineCountdown'),
  CInlineVideo: () => import('./CInlineVideo/CInlineVideo'),
  CLowStockIndicator: () => import('./CLowStockIndicator/CLowStockIndicator'),
  CProduct: () => import('./CProduct/CProduct'),
  CRow: () => import('./CRow/CRow'),
  CSection: () => import('./CSection/CSection'),
  CStepDisplay: () => import('./CStepDisplay/CStepDisplay'),
  CTabs: () => import('./CTabs/CTabs'),
  CTestimonial: () => import('./CTestimonial/CTestimonial'),
  CTestimonialImage: () => import('./CTestimonialImage/CTestimonialImage'),
  CTestimonialLogo: () => import('./CTestimonialLogo/CTestimonialLogo'),
  CTestimonialFeature: () =>
    import('./CTestimonialFeature/CTestimonialFeature'),
  CTestimonialGrid: () => import('./CTestimonialGrid/CTestimonialGrid'),
  CText: () => import('./CText/CText'),
  CTitle: () => import('./CTitle/CTitle'),
  CUpsell: () => import('./CUpsell/CUpsell'),
  CVideoEmbed: () => import('./CVideoEmbed/CVideoEmbed'),
  CProgressBar: () => import('./CProgressBar/CProgressBar'),
  CShowMoreBox: () => import('./CShowMoreBox/CShowMoreBox'),
};
